type TWhenValue = unknown
type TWhenFunction = (val: TWhenValue) => boolean

export const isWhenFunction = (arg: any): arg is TWhenFunction => {
  return typeof arg === 'function'
}
